import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { MessageBody } from '../../containers/hrAssistant/components/Message.jsx';

const TypingAnimation = ({ message, setIsTyping }) => {
  const [typedMessage, setTypedMessage] = useState('');

  useEffect(() => {
    if (typedMessage.length) return null;

    let index = 0;

    const typingInterval = setInterval(() => {
      setTypedMessage(prevTypedMessage => {
        const nextChar = message.charAt(index);

        index++;
        return prevTypedMessage + nextChar;
      });

      // Stop typing animation when entire message is typed or forced stop
      if (index === message.length) {
        setIsTyping(false);
        clearInterval(typingInterval);
      }
    }, 5); // Adjust typing speed as needed

    return () => {
      clearInterval(typingInterval);
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [message, setIsTyping]);
  /* eslint-enable-next-line react-hooks/exhaustive-deps */

  return (
    <MessageBody isBot={true} variant="subtitle2">
      <Markdown remarkPlugins={[remarkGfm]}>{typedMessage}</Markdown>
    </MessageBody>
  );
};

export default TypingAnimation;

TypingAnimation.propTypes = {
  message: PropTypes.string,
  setIsTyping: PropTypes.func,
};
